<template>
  <div class="app-logout">
    <button @click="logOut()" class="button button--secondary">
      <slot name="lblButton">Logout</slot>
      <img src="files/lidl/images/new-icons/svg/arrow-right-from-bracket-blue.svg" alt="">
    </button>
  </div>
</template>

<script>
import logout from '@/mixins/logout'
import extraData from '@/mixins/extraData'

export default {
  name: 'LogOutV2',
  mixins: [
    logout,
    extraData()]
}
</script>
